module.exports = __webpack_public_path__ + "img/森萨塔.png";